// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export enum PublicationStatuses {
    Live = 'Live',
    Expired = 'Expired'
}
